// Authentication Actions
export const AUTHENTICATION_LOGIN_REQUEST = "AUTHENTICATION_LOGIN_REQUEST"
export const AUTHENTICATION_LOGIN_RESPONSE = "AUTHENTICATION_LOGIN_RESPONSE"
export const AUTHENTICATION_LOGIN_UNAUTHORIZED =
    "AUTHENTICATION_LOGIN_UNAUTHORIZED"
export const AUTHENTICATION_LOGIN_ERROR = "AUTHENTICATION_LOGIN_ERROR"
export const UNAUTHENTICATED = "UNAUTHENTICATED"
export const AUTHENTICATION_TOGGLE_FORM = "AUTHENTICATION_TOGGLE_FORM"
export const AUTHENTICATION_TOKEN_REQUEST = "AUTHENTICATION_TOKEN_REQUEST"
export const AUTHENTICATION_TOKEN_RESPONSE = "AUTHENTICATION_TOKEN_RESPONSE"
export const SET_HAS_BEEN_ACTIVE = "SET_HAS_BEEN_ACTIVE"
export const TIMER_REFRESH = "TIMER_REFRESH"

// Authentication Forgot Actions
export const AUTHENTICATION_FORGOT_REQUEST = "AUTHENTICATION_FORGOT_REQUEST"
export const AUTHENTICATION_FORGOT_RESPONSE = "AUTHENTICATION_FORGOT_RESPONSE"
export const AUTHENTICATION_FORGOT_ERROR = "AUTHENTICATION_FORGOT_ERROR"

// NavBar Actions
export const NAVBAR_ITEM_SELECTED = "NAVBAR_ITEM_SELECTED"

// Alert Actions
export const ADD_ALERT = "ADD_ALERT"
export const REMOVE_ALERT = "REMOVE_ALERT"

// Attachment Actions
export const ATTACHMENT_ITEM_REQUEST = "ATTACHMENT_ITEM_REQUEST"
export const ATTACHMENT_ITEM_RESPONSE = "ATTACHMENT_ITEM_RESPONSE"
export const ATTACHMENT_ITEM_SAVE_REQUEST = "ATTACHMENT_ITEM_SAVE_REQUEST"
export const ATTACHMENT_ITEM_SAVE_RESPONSE = "ATTACHMENT_ITEM_SAVE_RESPONSE"
export const ATTACHMENT_ITEM_ERROR_RESPONSE = "ATTACHMENT_ITEM_ERROR_RESPONSE"
export const ATTACHMENT_ITEM_DELETE_REQUEST = "ATTACHMENT_ITEM_DELETE_REQUEST"
export const ATTACHMENT_ITEM_DELETE_RESPONSE = "ATTACHMENT_ITEM_DELETE_RESPONSE"
export const ATTACHMENT_ITEM_DELETE_ERROR_RESPONSE =
    "ATTACHMENT_ITEM_DELETE_ERROR_RESPONSE"
export const ATTACHMENT_LIST_REQUEST = "ATTACHMENT_LIST_REQUEST"
export const ATTACHMENT_LIST_RESPONSE = "ATTACHMENT_LIST_RESPONSE"
export const ATTACHMENT_LIST_CACHED_RESPONSE = "ATTACHMENT_LIST_CACHED_RESPONSE"
export const ATTACHMENT_LIST_ERROR_RESPONSE = "ATTACHMENT_LIST_ERROR_RESPONSE"
export const ATTACHMENT_UPDATE_DELETE_MODEL = "ATTACHMENT_UPDATE_DELETE_MODEL"
export const ATTACHMENT_UPDATE_REMOVE_MODEL = "ATTACHMENT_UPDATE_REMOVE_MODEL"
export const ATTACHMENT_UPDATE_ADD_MODEL = "ATTACHMENT_UPDATE_ADD_MODEL"

// Autocomplete Actions
export const AUTOCOMPLETE_REQUEST = "AUTOCOMPLETE_REQUEST"
export const AUTOCOMPLETE_COMMUNITY_LABELS_REQUEST =
    "AUTOCOMPLETE_COMMUNITY_LABELS_REQUEST"
export const AUTOCOMPLETE_COMMUNITY_SYSTEM_LABELS_REQUEST =
    "AUTOCOMPLETE_COMMUNITY_SYSTEM_LABELS_REQUEST"
export const AUTOCOMPLETE_USERS_WITH_EMAIL_REQUEST =
    "AUTOCOMPLETE_USERS_WITH_EMAIL_REQUEST"
export const AUTOCOMPLETE_PROJECTS_REQUEST = "AUTOCOMPLETE_PROJECTS_REQUEST"
export const AUTOCOMPLETE_CONCEPTS_REQUEST = "AUTOCOMPLETE_CONCEPTS_REQUEST"
export const AUTOCOMPLETE_SOURCES_REQUEST = "AUTOCOMPLETE_SOURCES_REQUEST"
export const AUTOCOMPLETE_RESPONSE = "AUTOCOMPLETE_RESPONSE"
export const AUTOCOMPLETE_ERROR_RESPONSE = "AUTOCOMPLETE_ERROR_RESPONSE"

// Knowledge Actions
export const KNOWLEDGE_LIST_REQUEST = "KNOWLEDGE_LIST_REQUEST"
export const KNOWLEDGE_LIST_RESPONSE = "KNOWLEDGE_LIST_RESPONSE"
export const KNOWLEDGE_LIST_CACHED_RESPONSE = "KNOWLEDGE_LIST_CACHED_RESPONSE"
export const KNOWLEDGE_LIST_ERROR_RESPONSE = "KNOWLEDGE_LIST_ERROR_RESPONSE"
export const KNOWLEDGE_ITEM_REQUEST = "KNOWLEDGE_ITEM_REQUEST"
export const KNOWLEDGE_ITEM_RESPONSE = "KNOWLEDGE_ITEM_RESPONSE"
export const KNOWLEDGE_ITEM_CACHED_RESPONSE = "KNOWLEDGE_ITEM_CACHED_RESPONSE"
export const KNOWLEDGE_ITEM_ERROR_RESPONSE = "KNOWLEDGE_ITEM_ERROR_RESPONSE"
export const KNOWLEDGE_ITEM_SAVE_REQUEST = "KNOWLEDGE_ITEM_SAVE_REQUEST"
export const KNOWLEDGE_ITEM_SAVE_RESPONSE = "KNOWLEDGE_ITEM_SAVE_RESPONSE"
export const KNOWLEDGE_ITEM_SAVE_ERROR_RESPONSE =
    "KNOWLEDGE_ITEM_SAVE_ERROR_RESPONSE"
export const KNOWLEDGE_ANALYSE_REQUEST = "KNOWLEDGE_ANALYSE_REQUEST"
export const KNOWLEDGE_ANALYSE_ERROR_RESPONSE =
    "KNOWLEDGE_ANALYSE_ERROR_RESPONSE"

// Moderation Feed Actions
export const MODERATION_FEED_LIST_REQUEST = "MODERATION_FEED_LIST_REQUEST"
export const MODERATION_FEED_LIST_RESPONSE = "MODERATION_FEED_LIST_RESPONSE"
export const MODERATION_FEED_LIST_CACHED_RESPONSE =
    "MODERATION_FEED_LIST_CACHED_RESPONSE"
export const MODERATION_FEED_LIST_ERROR_RESPONSE =
    "MODERATION_FEED_LIST_ERROR_RESPONSE"
export const MODERATION_FEED_ITEM_REQUEST = "MODERATION_FEED_ITEM_REQUEST"
export const MODERATION_FEED_ITEM_RESPONSE = "MODERATION_FEED_ITEM_RESPONSE"
export const MODERATION_FEED_ITEM_CACHED_RESPONSE =
    "MODERATION_FEED_ITEM_CACHED_RESPONSE"
export const MODERATION_FEED_ITEM_ERROR_RESPONSE =
    "MODERATION_FEED_ITEM_ERROR_RESPONSE"
export const MODERATION_FEED_ITEM_FULLTEXT_REQUEST =
    "MODERATION_FEED_ITEM_FULLTEXT_REQUEST"
export const MODERATION_FEED_ITEM_FULLTEXT_RESPONSE =
    "MODERATION_FEED_ITEM_FULLTEXT_RESPONSE"
export const MODERATION_FEED_ITEM_FULLTEXT_CACHED_RESPONSE =
    "MODERATION_FEED_ITEM_FULLTEXT_CACHED_RESPONSE"
export const MODERATION_FEED_ITEM_FULLTEXT_ERROR_RESPONSE =
    "MODERATION_FEED_ITEM_FULLTEXT_ERROR_RESPONSE"
export const MODERATION_FEED_ITEM_SAVE_REQUEST =
    "MODERATION_FEED_ITEM_SAVE_REQUEST"
export const MODERATION_FEED_ITEM_SAVE_RESPONSE =
    "MODERATION_FEED_ITEM_SAVE_RESPONSE"
export const MODERATION_FEED_ITEM_SAVE_ERROR_RESPONSE =
    "MODERATION_FEED_ITEM_SAVE_ERROR_RESPONSE"
export const MODERATION_FEED_ANALYSE_REQUEST = "MODERATION_FEED_ANALYSE_REQUEST"
export const MODERATION_FEED_ANALYSE_ERROR_RESPONSE =
    "MODERATION_FEED_ANALYSE_ERROR_RESPONSE"

// Knowledge Data Actions
export const KNOWLEDGE_DATA_LIST_REQUEST = "KNOWLEDGE_DATA_LIST_REQUEST"
export const KNOWLEDGE_DATA_LIST_RESPONSE = "KNOWLEDGE_DATA_LIST_RESPONSE"
export const KNOWLEDGE_DATA_LIST_CACHED_RESPONSE =
    "KNOWLEDGE_DATA_LIST_CACHED_RESPONSE"
export const KNOWLEDGE_DATA_LIST_ERROR_RESPONSE =
    "KNOWLEDGE_DATA_LIST_ERROR_RESPONSE"

// Dashboard Actions
export const DASHBOARD_INFO_REQUEST = "DASHBOARD_INFO_REQUEST"
export const DASHBOARD_INFO_RESPONSE = "DASHBOARD_INFO_RESPONSE"
export const DASHBOARD_INFO_CACHED_RESPONSE = "DASHBOARD_INFO_CACHED_RESPONSE"
export const DASHBOARD_INFO_ERROR_RESPONSE = "DASHBOARD_INFO_ERROR_RESPONSE"
export const DASHBOARD_KNOWLEDGE_SEARCH_REQUEST =
    "DASHBOARD_KNOWLEDGE_SEARCH_REQUEST"
export const DASHBOARD_KNOWLEDGE_PAGE_REQUEST =
    "DASHBOARD_KNOWLEDGE_PAGE_REQUEST"
export const DASHBOARD_KNOWLEDGE_RESPONSE = "DASHBOARD_KNOWLEDGE_RESPONSE"

// Feed Actions
export const FEED_KNOWLEDGE_LIST_SEARCH_REQUEST =
    "FEED_KNOWLEDGE_LIST_SEARCH_REQUEST"
export const FEED_KNOWLEDGE_LIST_PAGE_REQUEST =
    "FEED_KNOWLEDGE_LIST_PAGE_REQUEST"
export const FEED_KNOWLEDGE_LIST_RESPONSE = "FEED_KNOWLEDGE_LIST_RESPONSE"
export const FEED_KNOWLEDGE_ITEM_REQUEST = "FEED_KNOWLEDGE_ITEM_REQUEST"
export const FEED_KNOWLEDGE_ITEM_RESPONSE = "FEED_KNOWLEDGE_ITEM_RESPONSE"
export const FEED_KNOWLEDGE_ITEM_FULLTEXT_RESPONSE =
    "FEED_KNOWLEDGE_ITEM_FULLTEXT_RESPONSE"
export const FEED_SET_KNOWLEDGE_FILTER = "FEED_SET_KNOWLEDGE_FILTER"
export const FEED_UPDATE_FILTER_CRITERIA = "FEED_UPDATE_FILTER_CRITERIA"
export const FEED_CLEAR_FILTER_CRITERIA = "FEED_CLEAR_FILTER_CRITERIA"
export const FEED_APPLY_FILTER_CRITERIA = "FEED_APPLY_FILTER_CRITERIA"
export const FEED_SET_EDIT_MODE = "FEED_SET_EDIT_MODE"
export const FEED_UPDATE_IMAGE = "FEED_UPDATE_IMAGE"
export const FEED_UPDATE_MODEL = "FEED_UPDATE_MODEL"
export const FEED_APPLY_MODEL_UPDATE = "FEED_APPLY_MODEL_UPDATE"
export const FEED_CANCEL_MODEL_UPDATE = "FEED_CANCEL_MODEL_UPDATE"
export const FEED_MODERATE = "FEED_MODERATE"
export const FEED_TOGGLE_REJECTION_REASON_MODAL =
    "FEED_TOGGLE_REJECTION_REASON_MODAL"

// Add Feed Actions
export const ADD_FEED_PREVIEW_TYPING = "ADD_FEED_PREVIEW_TYPING"
export const ADD_FEED_PREVIEW_REQUEST = "ADD_FEED_PREVIEW_REQUEST"
export const ADD_FEED_PREVIEW_RESPONSE = "ADD_FEED_PREVIEW_RESPONSE"
export const ADD_FEED_ANALYSE_REQUEST = "ADD_FEED_ANALYSE_REQUEST"
export const ADD_FEED_ANALYSE_RESPONSE = "ADD_FEED_ANALYSE_RESPONSE"
export const ADD_FEED_UPDATE_IMAGE = "ADD_FEED_UPDATE_IMAGE"
export const ADD_FEED_UPDATE_MODEL = "ADD_FEED_UPDATE_MODEL"
export const ADD_FEED_APPLY_MODEL_UPDATE = "ADD_FEED_APPLY_MODEL_UPDATE"
export const ADD_FEED_CANCEL_MODEL_UPDATE = "ADD_FEED_CANCEL_MODEL_UPDATE"
export const ADD_FEED_MODERATE = "ADD_FEED_MODERATE"
export const ADD_FEED_CLOSE = "ADD_FEED_CLOSE"
export const ADD_FEED_TOGGLE_REJECTION_REASON_MODAL =
    "ADD_FEED_TOGGLE_REJECTION_REASON_MODAL"

// Cluster Actions
export const CLUSTER_LIST_REQUEST = "CLUSTER_LIST_REQUEST"
export const CLUSTER_LIST_SEARCH_REQUEST = "CLUSTER_LIST_SEARCH_REQUEST"
export const CLUSTER_LIST_CACHED_RESPONSE = "CLUSTER_LIST_CACHED_RESPONSE"
export const CLUSTER_LIST_RESPONSE = "CLUSTER_LIST_RESPONSE"
export const CLUSTER_LIST_ERROR_RESPONSE = "CLUSTER_LIST_ERROR_RESPONSE"
export const CLUSTER_ITEM_REQUEST = "CLUSTER_ITEM_REQUEST"
export const CLUSTER_ITEM_RESPONSE = "CLUSTER_ITEM_RESPONSE"
export const CLUSTER_ITEM_CACHED_RESPONSE = "CLUSTER_ITEM_CACHED_RESPONSE"
export const CLUSTER_ITEM_ERROR_RESPONSE = "CLUSTER_ITEM_ERROR_RESPONSE"
export const CLUSTER_ITEM_SAVE_REQUEST = "CLUSTER_ITEM_SAVE_REQUEST"
export const CLUSTER_ITEM_SAVE_RESPONSE = "CLUSTER_ITEM_SAVE_RESPONSE"
export const CLUSTER_ITEM_DELETE_REQUEST = "CLUSTER_ITEM_DELETE_REQUEST"
export const CLUSTER_ITEM_DELETE_RESPONSE = "CLUSTER_ITEM_DELETE_RESPONSE"
export const CLUSTER_ITEM_DELETE_ERROR_RESPONSE =
    "CLUSTER_ITEM_DELETE_ERROR_RESPONSE"
export const CLUSTER_SET_FILTER = "CLUSTER_SET_FILTER"
export const CLUSTER_SET_EDIT_MODE = "CLUSTER_SET_EDIT_MODE"
export const CLUSTER_UPDATE_FILTER_CRITERIA = "CLUSTER_UPDATE_FILTER_CRITERIA"
export const CLUSTER_CLEAR_FILTER_CRITERIA = "CLUSTER_CLEAR_FILTER_CRITERIA"
export const CLUSTER_APPLY_FILTER_CRITERIA = "CLUSTER_APPLY_FILTER_CRITERIA"
export const CLUSTER_UPDATE_IMAGE = "CLUSTER_UPDATE_IMAGE"
export const CLUSTER_UPDATE_MODEL = "CLUSTER_UPDATE_MODEL"
export const CLUSTER_APPLY_MODEL_UPDATE = "CLUSTER_APPLY_MODEL_UPDATE"
export const CLUSTER_CANCEL_MODEL_UPDATE = "CLUSTER_CANCEL_MODEL_UPDATE"
export const CLUSTER_ADD_NEW = "CLUSTER_ADD_NEW"
export const CLUSTER_MODERATE = "CLUSTER_MODERATE"
export const CLUSTER_ARTICLE_SEARCH_REQUEST = "CLUSTER_ARTICLE_SEARCH_REQUEST"
export const CLUSTER_ARTICLE_SEARCH_RESPONSE = "CLUSTER_ARTICLE_SEARCH_RESPONSE"
export const CLUSTER_ARTICLE_EDIT_SELECT = "CLUSTER_ARTICLE_EDIT_SELECT"
export const CLUSTER_CONCEPTS_SEARCH_REQUEST = "CLUSTER_CONCEPTS_SEARCH_REQUEST"
export const CLUSTER_CONCEPTS_SEARCH_RESPONSE =
    "CLUSTER_CONCEPTS_SEARCH_RESPONSE"
export const CLUSTER_TOPIC_EDIT_SELECT = "CLUSTER_TOPIC_EDIT_SELECT"

// Source Actions
export const SOURCE_LIST_REQUEST = "SOURCE_LIST_REQUEST"
export const SOURCE_LIST_SEARCH_REQUEST = "SOURCE_LIST_SEARCH_REQUEST"
export const SOURCE_LIST_CACHED_RESPONSE = "SOURCE_LIST_CACHED_RESPONSE"
export const SOURCE_LIST_RESPONSE = "SOURCE_LIST_RESPONSE"
export const SOURCE_LIST_ERROR_RESPONSE = "SOURCE_LIST_ERROR_RESPONSE"
export const SOURCE_ITEM_REQUEST = "SOURCE_ITEM_REQUEST"
export const SOURCE_ITEM_RESPONSE = "SOURCE_ITEM_RESPONSE"
export const SOURCE_ITEM_CACHED_RESPONSE = "SOURCE_ITEM_CACHED_RESPONSE"
export const SOURCE_ITEM_ERROR_RESPONSE = "SOURCE_ITEM_ERROR_RESPONSE"
export const SOURCE_ITEM_SAVE_REQUEST = "SOURCE_ITEM_SAVE_REQUEST"
export const SOURCE_ITEM_SAVE_RESPONSE = "SOURCE_ITEM_SAVE_RESPONSE"
export const SOURCE_ITEM_SAVE_ERROR_RESPONSE = "SOURCE_ITEM_SAVE_ERROR_RESPONSE"
export const SOURCE_ITEM_DELETE_REQUEST = "SOURCE_ITEM_DELETE_REQUEST"
export const SOURCE_ITEM_DELETE_RESPONSE = "SOURCE_ITEM_DELETE_RESPONSE"
export const SOURCE_ITEM_DELETE_ERROR_RESPONSE =
    "SOURCE_ITEM_DELETE_ERROR_RESPONSE"
export const SOURCE_SET_FILTER = "SOURCE_SET_FILTER"
export const SOURCE_SET_EDIT_MODE = "SOURCE_SET_EDIT_MODE"
export const SOURCE_UPDATE_FILTER_CRITERIA = "SOURCE_UPDATE_FILTER_CRITERIA"
export const SOURCE_CLEAR_FILTER_CRITERIA = "SOURCE_CLEAR_FILTER_CRITERIA"
export const SOURCE_APPLY_FILTER_CRITERIA = "SOURCE_APPLY_FILTER_CRITERIA"
export const SOURCE_UPDATE_IMAGE = "SOURCE_UPDATE_IMAGE"
export const SOURCE_UPDATE_MODEL = "SOURCE_UPDATE_MODEL"
export const SOURCE_APPLY_MODEL_UPDATE = "SOURCE_APPLY_MODEL_UPDATE"
export const SOURCE_CANCEL_MODEL_UPDATE = "SOURCE_CANCEL_MODEL_UPDATE"
export const SOURCE_ADD_NEW = "SOURCE_ADD_NEW"
export const SOURCE_RENDERED_LISTING_TEST_LINK =
    "SOURCE_RENDERED_LISTING_TEST_LINK"
export const SOURCE_RENDERED_LISTING_CHECK_RESPONSE =
    "SOURCE_RENDERED_LISTING_CHECK_RESPONSE"
export const SOURCE_RENDERED_LISTING_CHECK_ERROR_RESPONSE =
    "SOURCE_RENDERED_LISTING_CHECK_ERROR_RESPONSE"
export const SOURCE_RENDERED_LISTING_DISCOVER_REQUEST =
    "SOURCE_RENDERED_LISTING_DISCOVER_REQUEST"
export const SOURCE_RENDERED_LISTING_DISCOVER_RESPONSE =
    "SOURCE_RENDERED_LISTING_DISCOVER_RESPONSE"
export const SOURCE_RENDERED_LISTING_DISCOVER_ERROR_RESPONSE =
    "SOURCE_RENDERED_LISTING_DISCOVER_ERROR_RESPONSE"

// Topic Request/Response Actions
export const TOPIC_LIST_REQUEST = "TOPIC_LIST_REQUEST"
export const TOPIC_LIST_RESPONSE = "TOPIC_LIST_RESPONSE"
export const TOPIC_LIST_CACHED_RESPONSE = "TOPIC_LIST_CACHED_RESPONSE"
export const TOPIC_LIST_ERROR_RESPONSE = "TOPIC_LIST_ERROR_RESPONSE"
export const TOPIC_LIST_COUNT_REQUEST = "TOPIC_LIST_COUNT_REQUEST"
export const TOPIC_LIST_COUNT_RESPONSE = "TOPIC_LIST_COUNT_RESPONSE"
export const TOPIC_LIST_COUNT_CACHED_RESPONSE =
    "TOPIC_LIST_COUNT_CACHED_RESPONSE"
export const TOPIC_LIST_COUNT_ERROR_RESPONSE = "TOPIC_LIST_COUNT_ERROR_RESPONSE"
export const TOPIC_ITEM_REQUEST = "TOPIC_ITEM_REQUEST"
export const TOPIC_ITEM_RESPONSE = "TOPIC_ITEM_RESPONSE"
export const TOPIC_ITEM_CACHED_RESPONSE = "TOPIC_ITEM_CACHED_RESPONSE"
export const TOPIC_ITEM_ERROR_RESPONSE = "TOPIC_ITEM_ERROR_RESPONSE"
export const TOPIC_ITEM_SAVE_REQUEST = "TOPIC_ITEM_SAVE_REQUEST"
export const TOPIC_ITEM_SAVE_RESPONSE = "TOPIC_ITEM_SAVE_RESPONSE"
export const TOPIC_ITEM_SAVE_ERROR_RESPONSE = "TOPIC_ITEM_SAVE_ERROR_RESPONSE"
export const TOPIC_ITEM_SYNC_REQUEST = "TOPIC_ITEM_SYNC_REQUEST"
export const TOPIC_ITEM_SYNC_RESPONSE = "TOPIC_ITEM_SYNC_RESPONSE"
export const TOPIC_ITEM_SYNC_ERROR_RESPONSE = "TOPIC_ITEM_SYNC_ERROR_RESPONSE"
export const TOPIC_FINGERPRINT_REQUEST = "TOPIC_FINGERPRINT_REQUEST"
export const TOPIC_FINGERPRINT_RESPONSE = "TOPIC_FINGERPRINT_RESPONSE"
export const TOPIC_FINGERPRINT_CACHED_RESPONSE =
    "TOPIC_FINGERPRINT_CACHED_RESPONSE"
export const TOPIC_FINGERPRINT_ERROR_RESPONSE =
    "TOPIC_FINGERPRINT_ERROR_RESPONSE"
export const TOPIC_FINGERPRINT_PREVIEW_REQUEST =
    "TOPIC_FINGERPRINT_PREVIEW_REQUEST"
export const TOPIC_FINGERPRINT_PREVIEW_RESPONSE =
    "TOPIC_FINGERPRINT_PREVIEW_RESPONSE"
export const TOPIC_FINGERPRINT_PREVIEW_ERROR_RESPONSE =
    "TOPIC_FINGERPRINT_PREVIEW_ERROR_RESPONSE"
export const TOPIC_VOLUMES = "TOPIC_VOLUMES"
export const TOPIC_KNOWLEDGE = "TOPIC_KNOWLEDGE"
export const ADVANCED_MODE_CLOSED = "ADVANCED_MODE_CLOSED"
export const TOPIC_TIMESTAMP_SELECTED = "TOPIC_TIMESTAMP_SELECTED"
export const TOPIC_SELECTED_AS_EVIDENCE = "TOPIC_SELECTED_AS_EVIDENCE"
export const TOGGLE_ADVANCED_MODE_MODERATION = "TOGGLE_ADVANCED_MODE_MODERATION"

// Insight Area Presentation Actions
export const INSIGHT_AREA_LIST_SEARCH_REQUEST =
    "INSIGHT_AREA_LIST_SEARCH_REQUEST"
export const INSIGHT_AREA_LIST_PAGE_REQUEST = "INSIGHT_AREA_LIST_PAGE_REQUEST"
export const INSIGHT_AREA_LIST_RESPONSE = "INSIGHT_AREA_LIST_RESPONSE"
export const INSIGHT_AREA_ITEM_REQUEST = "INSIGHT_AREA_ITEM_REQUEST"
export const INSIGHT_AREA_ITEM_RESPONSE = "INSIGHT_AREA_ITEM_RESPONSE"
export const INSIGHT_AREA_ITEM_SAVE_RESPONSE = "INSIGHT_AREA_ITEM_SAVE_RESPONSE"
export const INSIGHT_AREA_SET_FILTER = "INSIGHT_AREA_SET_FILTER"
export const INSIGHT_AREA_SET_EDIT_MODE = "INSIGHT_AREA_SET_EDIT_MODE"
export const INSIGHT_AREA_UPDATE_FILTER_CRITERIA =
    "INSIGHT_AREA_UPDATE_FILTER_CRITERIA"
export const INSIGHT_AREA_CLEAR_FILTER_CRITERIA =
    "INSIGHT_AREA_CLEAR_FILTER_CRITERIA"
export const INSIGHT_AREA_APPLY_FILTER_CRITERIA =
    "INSIGHT_AREA_APPLY_FILTER_CRITERIA"
export const INSIGHT_AREA_UPDATE_IMAGE = "INSIGHT_AREA_UPDATE_IMAGE"
export const INSIGHT_AREA_UPDATE_MODEL = "INSIGHT_AREA_UPDATE_MODEL"
export const INSIGHT_AREA_APPLY_MODEL_UPDATE = "INSIGHT_AREA_APPLY_MODEL_UPDATE"
export const INSIGHT_AREA_CANCEL_MODEL_UPDATE =
    "INSIGHT_AREA_CANCEL_MODEL_UPDATE"
export const INSIGHT_AREA_ADD_NEW = "INSIGHT_AREA_ADD_NEW"
export const INSIGHT_AREA_FINISH_SAVING = "INSIGHT_AREA_FINISH_SAVING"
export const INSIGHT_AREA_FINISH_SAVING_ERROR =
    "INSIGHT_AREA_FINISH_SAVING_ERROR"
export const INSIGHT_AREA_ITEM_SYNC_REQUEST = "INSIGHT_AREA_ITEM_SYNC_REQUEST"
export const INSIGHT_AREA_ITEM_SYNC_RESPONSE = "INSIGHT_AREA_ITEM_SYNC_RESPONSE"

// Insight Area Placeholder Actions
export const INSIGHT_AREA_ADD_PLACEHOLDER_IMAGES =
    "INSIGHT_AREA_ADD_PLACEHOLDER_IMAGES"
export const INSIGHT_AREA_UPDATE_PLACEHOLDER_ATTRIBUTION =
    "INSIGHT_AREA_UPDATE_PLACEHOLDER_ATTRIBUTION"
export const INSIGHT_AREA_REMOVE_PLACEHOLDER = "INSIGHT_AREA_REMOVE_PLACEHOLDER"

// Insight Area Mapping Actions
export const INSIGHT_AREA_ADD_MAPPING = "INSIGHT_AREA_ADD_MAPPING"
export const INSIGHT_AREA_REMOVE_MAPPING = "INSIGHT_AREA_REMOVE_MAPPING"
export const INSIGHT_AREA_MAPPING_PREVIEW_REQUEST =
    "INSIGHT_AREA_MAPPING_PREVIEW_REQUEST"
export const INSIGHT_AREA_MAPPING_DELETE_PREVIEW_REQUEST =
    "INSIGHT_AREA_MAPPING_DELETE_PREVIEW_REQUEST"
export const INSIGHT_AREA_MAPPING_PREVIEW_RESPONSE =
    "INSIGHT_AREA_MAPPING_PREVIEW_RESPONSE"
export const INSIGHT_AREA_MAPPING_PREVIEW_ERROR_RESPONSE =
    "INSIGHT_AREA_MAPPING_PREVIEW_ERROR_RESPONSE"
export const INSIGHT_AREA_FINGERPRINT_REMOVE_CONCEPT =
    "INSIGHT_AREA_FINGERPRINT_REMOVE_CONCEPT"
export const INSIGHT_AREA_FINGERPRINT_PREVIEW_REQUEST =
    "INSIGHT_AREA_FINGERPRINT_PREVIEW_REQUEST"
export const INSIGHT_AREA_FINGERPRINT_PREVIEW_RESPONSE =
    "INSIGHT_AREA_FINGERPRINT_PREVIEW_RESPONSE"
export const INSIGHT_AREA_FINGERPRINT_PREVIEW_ERROR_RESPONSE =
    "INSIGHT_AREA_FINGERPRINT_PREVIEW_ERROR_RESPONSE"

// Insight Area Owner/Viewer Actions
export const INSIGHT_AREA_SELECT_PERMISSION_HOLDER_TYPE =
    "INSIGHT_AREA_SELECT_PERMISSION_HOLDER_TYPE"
export const INSIGHT_AREA_REMOVE_OWNER_VIEWER =
    "INSIGHT_AREA_REMOVE_OWNER_VIEWER"
export const INSIGHT_AREA_SEARCH_ADD_OWNERS_VIEWERS =
    "INSIGHT_AREA_SEARCH_ADD_OWNERS_VIEWERS"
export const INSIGHT_AREA_SEARCH_ADD_OWNERS_VIEWERS_RESPONSE =
    "INSIGHT_AREA_SEARCH_ADD_OWNERS_VIEWERS_RESPONSE"
export const INSIGHT_AREA_SELECT_ADD_OWNER_VIEWER =
    "INSIGHT_AREA_SELECT_ADD_OWNER_VIEWER"
export const INSIGHT_AREA_APPLY_ADD_OWNERS_VIEWERS =
    "INSIGHT_AREA_APPLY_ADD_OWNERS_VIEWERS"
export const INSIGHT_AREA_CANCEL_ADD_OWNERS_VIEWERS =
    "INSIGHT_AREA_CANCEL_ADD_OWNERS_VIEWERS"

// Dimension Request/Reponse Actions
export const DIMENSION_LIST_REQUEST = "DIMENSION_LIST_REQUEST"
export const DIMENSION_LIST_RESPONSE = "DIMENSION_LIST_RESPONSE"
export const DIMENSION_LIST_CACHED_RESPONSE = "DIMENSION_LIST_CACHED_RESPONSE"
export const DIMENSION_LIST_ERROR_RESPONSE = "DIMENSION_LIST_ERROR_RESPONSE"
export const DIMENSION_LIST_COUNT_REQUEST = "DIMENSION_LIST_COUNT_REQUEST"
export const DIMENSION_LIST_COUNT_RESPONSE = "DIMENSION_LIST_COUNT_RESPONSE"
export const DIMENSION_LIST_COUNT_CACHED_RESPONSE =
    "DIMENSION_LIST_COUNT_CACHED_RESPONSE"
export const DIMENSION_LIST_COUNT_ERROR_RESPONSE =
    "DIMENSION_LIST_COUNT_ERROR_RESPONSE"
export const DIMENSION_ITEM_REQUEST = "DIMENSION_ITEM_REQUEST"
export const DIMENSION_ITEM_RESPONSE = "DIMENSION_ITEM_RESPONSE"
export const DIMENSION_ITEM_CACHED_RESPONSE = "DIMENSION_ITEM_CACHED_RESPONSE"
export const DIMENSION_ITEM_ERROR_RESPONSE = "DIMENSION_ITEM_ERROR_RESPONSE"
export const DIMENSION_ITEM_SAVE_REQUEST = "DIMENSION_ITEM_SAVE_REQUEST"
export const DIMENSION_ITEM_SAVE_RESPONSE = "DIMENSION_ITEM_SAVE_RESPONSE"
export const DIMENSION_ITEM_SAVE_ERROR_RESPONSE =
    "DIMENSION_ITEM_SAVE_ERROR_RESPONSE"
export const DIMENSION_WIZARD_REQUEST = "DIMENSION_WIZARD_REQUEST"
export const DIMENSION_WIZARD_RESPONSE = "DIMENSION_WIZARD_RESPONSE"
export const DIMENSION_WIZARD_ERROR_RESPONSE = "DIMENSION_WIZARD_ERROR_RESPONSE"

// Key Issue Presentation Actions
export const KEY_ISSUE_LIST_SEARCH_REQUEST = "KEY_ISSUE_LIST_SEARCH_REQUEST"
export const KEY_ISSUE_LIST_PAGE_REQUEST = "KEY_ISSUE_LIST_PAGE_REQUEST"
export const KEY_ISSUE_LIST_RESPONSE = "KEY_ISSUE_LIST_RESPONSE"
export const KEY_ISSUE_ITEM_REQUEST = "KEY_ISSUE_ITEM_REQUEST"
export const KEY_ISSUE_ITEM_RESPONSE = "KEY_ISSUE_ITEM_RESPONSE"
export const KEY_ISSUE_SET_FILTER = "KEY_ISSUE_SET_FILTER"
export const KEY_ISSUE_SET_EDIT_MODE = "KEY_ISSUE_SET_EDIT_MODE"
export const KEY_ISSUE_UPDATE_FILTER_CRITERIA =
    "KEY_ISSUE_UPDATE_FILTER_CRITERIA"
export const KEY_ISSUE_CLEAR_FILTER_CRITERIA = "KEY_ISSUE_CLEAR_FILTER_CRITERIA"
export const KEY_ISSUE_APPLY_FILTER_CRITERIA = "KEY_ISSUE_APPLY_FILTER_CRITERIA"
export const KEY_ISSUE_UPDATE_IMAGE = "KEY_ISSUE_UPDATE_IMAGE"
export const KEY_ISSUE_UPDATE_MODEL = "KEY_ISSUE_UPDATE_MODEL"
export const KEY_ISSUE_APPLY_MODEL_UPDATE = "KEY_ISSUE_APPLY_MODEL_UPDATE"
export const KEY_ISSUE_CANCEL_MODEL_UPDATE = "KEY_ISSUE_CANCEL_MODEL_UPDATE"
export const KEY_ISSUE_ADD_NEW = "KEY_ISSUE_ADD_NEW"
export const KEY_ISSUE_ITEM_SAVE_RESPONSE = "KEY_ISSUE_ITEM_SAVE_RESPONSE"

// Key Issue Placeholder Actions
export const KEY_ISSUE_ADD_PLACEHOLDER_IMAGES =
    "KEY_ISSUE_ADD_PLACEHOLDER_IMAGES"
export const KEY_ISSUE_UPDATE_PLACEHOLDER_ATTRIBUTION =
    "KEY_ISSUE_UPDATE_PLACEHOLDER_ATTRIBUTION"
export const KEY_ISSUE_REMOVE_PLACEHOLDER = "KEY_ISSUE_REMOVE_PLACEHOLDER"

// Key Issue Mapping Actions
export const KEY_ISSUE_UPDATE_CONCEPTS = "KEY_ISSUE_UPDATE_CONCEPTS"
export const KEY_ISSUE_CLEAR_CONCEPTS = "KEY_ISSUE_CLEAR_CONCEPTS"
export const KEY_ISSUE_ADD_MAPPING = "KEY_ISSUE_ADD_MAPPING"
export const KEY_ISSUE_REMOVE_MAPPING = "KEY_ISSUE_REMOVE_MAPPING"
export const KEY_ISSUE_MAPPING_PREVIEW_REQUEST =
    "KEY_ISSUE_MAPPING_PREVIEW_REQUEST"
export const KEY_ISSUE_MAPPING_DELETE_PREVIEW_REQUEST =
    "KEY_ISSUE_MAPPING_DELETE_PREVIEW_REQUEST"
export const KEY_ISSUE_MAPPING_PREVIEW_RESPONSE =
    "KEY_ISSUE_MAPPING_PREVIEW_RESPONSE"
export const KEY_ISSUE_MAPPING_PREVIEW_ERROR_RESPONSE =
    "KEY_ISSUE_MAPPING_PREVIEW_ERROR_RESPONSE"

// Key Issue Owner/Viewer Actions
export const KEY_ISSUE_SELECT_PERMISSION_HOLDER_TYPE =
    "KEY_ISSUE_SELECT_PERMISSION_HOLDER_TYPE"
export const KEY_ISSUE_REMOVE_OWNER_VIEWER = "KEY_ISSUE_REMOVE_OWNER_VIEWER"
export const KEY_ISSUE_SEARCH_ADD_OWNERS_VIEWERS =
    "KEY_ISSUE_SEARCH_ADD_OWNERS_VIEWERS"
export const KEY_ISSUE_SEARCH_ADD_OWNERS_VIEWERS_RESPONSE =
    "KEY_ISSUE_SEARCH_ADD_OWNERS_VIEWERS_RESPONSE"
export const KEY_ISSUE_SELECT_ADD_OWNER_VIEWER =
    "KEY_ISSUE_SELECT_ADD_OWNER_VIEWER"
export const KEY_ISSUE_APPLY_ADD_OWNERS_VIEWERS =
    "KEY_ISSUE_APPLY_ADD_OWNERS_VIEWERS"
export const KEY_ISSUE_CANCEL_ADD_OWNERS_VIEWERS =
    "KEY_ISSUE_CANCEL_ADD_OWNERS_VIEWERS"

// Studio Request/Response Actions
export const STUDIO_LIST_REQUEST = "STUDIO_LIST_REQUEST"
export const STUDIO_LIST_SEARCH_REQUEST = "STUDIO_LIST_SEARCH_REQUEST"
export const STUDIO_LIST_TYPE_CHANGE = "STUDIO_LIST_TYPE_CHANGE"
export const STUDIO_LIST_CACHED_RESPONSE = "STUDIO_LIST_CACHED_RESPONSE"
export const STUDIO_LIST_RESPONSE = "STUDIO_LIST_RESPONSE"
export const STUDIO_LIST_ERROR_RESPONSE = "STUDIO_LIST_ERROR_RESPONSE"
export const STUDIO_UPDATE_FILTER_CRITERIA = "STUDIO_UPDATE_FILTER_CRITERIA"
export const STUDIO_CLEAR_NAME_FILTER = "STUDIO_CLEAR_NAME_FILTER"
export const STUDIO_ITEM_REQUEST = "STUDIO_ITEM_REQUEST"
export const STUDIO_ITEM_RESPONSE = "STUDIO_ITEM_RESPONSE"
export const STUDIO_ITEM_ERROR_RESPONSE = "STUDIO_ITEM_ERROR_RESPONSE"
export const STUDIO_ITEM_CACHED_RESPONSE = "STUDIO_ITEM_CACHED_RESPONSE"
export const STUDIO_ITEM_SAVE_REQUEST = "STUDIO_ITEM_SAVE_REQUEST"
export const STUDIO_ITEM_SAVE_RESPONSE = "STUDIO_ITEM_SAVE_RESPONSE"
export const STUDIO_ITEM_SAVE_ERROR_RESPONSE = "STUDIO_ITEM_SAVE_ERROR_RESPONSE"
export const STUDIO_ITEM_DELETE_REQUEST = "STUDIO_ITEM_DELETE_REQUEST"
export const STUDIO_ITEM_DELETE_RESPONSE = "STUDIO_ITEM_DELETE_RESPONSE"
export const STUDIO_ITEM_DELETE_ERROR_RESPONSE =
    "STUDIO_ITEM_DELETE_ERROR_RESPONSE"

// Studio Extra Data Actions
export const STUDIO_DIMENSION_ITEM_REQUEST = "STUDIO_DIMENSION_ITEM_REQUEST"
export const STUDIO_DIMENSION_ITEM_RESPONSE = "STUDIO_DIMENSION_ITEM_RESPONSE"
export const STUDIO_KNOWLEDGE_LIST_REQUEST = "STUDIO_KNOWLEDGE_LIST_REQUEST"
export const STUDIO_KNOWLEDGE_LIST_RESPONSE = "STUDIO_KNOWLEDGE_LIST_RESPONSE"
export const STUDIO_KNOWLEDGE_ITEM_REQUEST = "STUDIO_KNOWLEDGE_ITEM_REQUEST"
export const STUDIO_KNOWLEDGE_ITEM_RESPONSE = "STUDIO_KNOWLEDGE_ITEM_RESPONSE"
export const STUDIO_STAKEHOLDERS_LIST_REQUEST =
    "STUDIO_STAKEHOLDERS_LIST_REQUEST"
export const STUDIO_STAKEHOLDERS_LIST_RESPONSE =
    "STUDIO_STAKEHOLDERS_LIST_RESPONSE"
export const STUDIO_SESSIONS_LIST_REQUEST = "STUDIO_SESSIONS_LIST_REQUEST"
export const STUDIO_SESSIONS_LIST_RESPONSE = "STUDIO_SESSIONS_LIST_RESPONSE"
export const STUDIO_PROJECTS_LIST_REQUEST = "STUDIO_PROJECTS_LIST_REQUEST"
export const STUDIO_PROJECTS_LIST_RESPONSE = "STUDIO_PROJECTS_LIST_RESPONSE"
export const STUDIO_REPORTS_LIST_REQUEST = "STUDIO_REPORTS_LIST_REQUEST"
export const STUDIO_REPORTS_LIST_RESPONSE = "STUDIO_REPORTS_LIST_RESPONSE"
export const STUDIO_KNOWLEDGE_DATA_LIST_REQUEST =
    "STUDIO_KNOWLEDGE_DATA_LIST_REQUEST"
export const STUDIO_KNOWLEDGE_DATA_LIST_RESPONSE =
    "STUDIO_KNOWLEDGE_DATA_LIST_RESPONSE"

// Studio Map Interaction Actions
export const STUDIO_HIGHLIGHT_DIMENSION = "STUDIO_HIGHLIGHT_DIMENSION"
export const STUDIO_HIGHLIGHT_DIMENSION_NEXT = "STUDIO_HIGHLIGHT_DIMENSION_NEXT"
export const STUDIO_HIGHLIGHT_DIMENSION_PREVIOUS =
    "STUDIO_HIGHLIGHT_DIMENSION_PREVIOUS"
export const STUDIO_HIGHLIGHT_TOPIC = "STUDIO_HIGHLIGHT_TOPIC"
export const STUDIO_CLONE_MAP = "STUDIO_CLONE_MAP"
export const STUDIO_NEW_MAP = "STUDIO_NEW_MAP"
export const STUDIO_SHOW_INTERACTIVE_DATA = "STUDIO_SHOW_INTERACTIVE_DATA"
export const STUDIO_HIDE_INTERACTIVE_DATA = "STUDIO_HIDE_INTERACTIVE_DATA"

// Studio Briefing Actions
export const STUDIO_TOGGLE_BRIEFING_EMAIL_MODAL =
    "STUDIO_TOGGLE_BRIEFING_EMAIL_MODAL"
export const STUDIO_BRIEFING_REQUEST = "STUDIO_BRIEFING_REQUEST"
export const STUDIO_BRIEFING_RESPONSE = "STUDIO_BRIEFING_RESPONSE"
export const STUDIO_BRIEFING_ERROR_RESPONSE = "STUDIO_BRIEFING_ERROR_RESPONSE"
export const STUDIO_BRIEFING_EMAIL_MODEL_UPDATE =
    "STUDIO_BRIEFING_EMAIL_MODEL_UPDATE"
export const STUDIO_BRIEFING_EMAIL_CANCEL = "STUDIO_BRIEFING_EMAIL_CANCEL"
export const STUDIO_BRIEFING_EMAIL_REQUEST = "STUDIO_BRIEFING_EMAIL_REQUEST"
export const STUDIO_BRIEFING_EMAIL_RESPONSE = "STUDIO_BRIEFING_EMAIL_RESPONSE"
export const STUDIO_BRIEFING_EMAIL_ERROR_RESPONSE =
    "STUDIO_BRIEFING_EMAIL_ERROR_RESPONSE"

// Studio Image Actions
export const STUDIO_TOGGLE_IMAGE_SETTINGS_MODAL =
    "STUDIO_TOGGLE_IMAGE_SETTINGS_MODAL"
export const STUDIO_DOWNLOAD_IMAGE_REQUEST = "STUDIO_DOWNLOAD_IMAGE_REQUEST"
export const STUDIO_DOWNLOAD_IMAGE_RESPONSE = "STUDIO_DOWNLOAD_IMAGE_RESPONSE"
export const STUDIO_DOWNLOAD_IMAGE_ERROR_RESPONSE =
    "STUDIO_DOWNLOAD_IMAGE_ERROR_RESPONSE"

// Studio Create Dimension Actions
export const STUDIO_DIMENSION_WIZARD_REQUEST = "STUDIO_DIMENSION_WIZARD_REQUEST"
export const STUDIO_DIMENSION_WIZARD_RESPONSE =
    "STUDIO_DIMENSION_WIZARD_RESPONSE"
export const STUDIO_DIMENSION_WIZARD_ERROR_RESPONSE =
    "STUDIO_DIMENSION_WIZARD_ERROR_RESPONSE"
export const STUDIO_CREATE_DIMENSION_APPLY_MODEL_UPDATE =
    "STUDIO_CREATE_DIMENSION_APPLY_MODEL_UPDATE"
export const STUDIO_CREATE_DIMENSION_UPDATE_MODEL =
    "STUDIO_CREATE_DIMENSION_UPDATE_MODEL"
export const STUDIO_CREATE_DIMENSION_SAVE_RESPONSE =
    "STUDIO_CREATE_DIMENSION_SAVE_RESPONSE"
export const STUDIO_CREATE_DIMENSION_CANCEL = "STUDIO_CREATE_DIMENSION_CANCEL"

// Studio Map Edit Interactions
export const STUDIO_EDIT_APPLY_MODEL_UPDATE = "STUDIO_EDIT_APPLY_MODEL_UPDATE"
export const STUDIO_EDIT_CANCEL_MODEL_UPDATE = "STUDIO_EDIT_CANCEL_MODEL_UPDATE"
export const STUDIO_EDIT_UPDATE_MODEL = "STUDIO_EDIT_UPDATE_MODEL"
export const STUDIO_EDIT_UPDATE_IMAGE = "STUDIO_EDIT_UPDATE_IMAGE"
export const STUDIO_EDIT_COPY_IMAGE_URL = "STUDIO_EDIT_COPY_IMAGE_URL"
export const STUDIO_EDIT_SELECT_TAB = "STUDIO_EDIT_SELECT_TAB"
export const STUDIO_EDIT_TOPIC_DIMENSION_SEARCH =
    "STUDIO_EDIT_TOPIC_DIMENSION_SEARCH"
export const STUDIO_EDIT_RELATED_DIMENSIONS_LIST_REQUEST =
    "STUDIO_EDIT_RELATED_DIMENSIONS_LIST_REQUEST"
export const STUDIO_EDIT_RELATED_DIMENSIONS_LIST_RESPONSE =
    "STUDIO_EDIT_RELATED_DIMENSIONS_LIST_RESPONSE"
export const STUDIO_EDIT_DESELECT_TOPIC = "STUDIO_EDIT_DESELECT_TOPIC"
export const STUDIO_EDIT_REMOVE_KEY_ISSUE = "STUDIO_EDIT_REMOVE_KEY_ISSUE"
export const STUDIO_EDIT_CLEAR_KEY_ISSUES = "STUDIO_EDIT_CLEAR_KEY_ISSUES"
export const STUDIO_EDIT_ADD_KEY_ISSUES_REQUEST =
    "STUDIO_EDIT_ADD_KEY_ISSUES_REQUEST"
export const STUDIO_EDIT_ADD_KEY_ISSUES_RESPONSE =
    "STUDIO_EDIT_ADD_KEY_ISSUES_RESPONSE"
export const STUDIO_EDIT_KEY_ISSUE_DRAG_START =
    "STUDIO_EDIT_KEY_ISSUE_DRAG_START"
export const STUDIO_EDIT_KEY_ISSUE_DRAG_END = "STUDIO_EDIT_KEY_ISSUE_DRAG_END"
export const STUDIO_EDIT_TOGGLE_IMAGE_UPLOAD_MODAL =
    "STUDIO_EDIT_TOGGLE_IMAGE_UPLOAD_MODAL"
export const STUDIO_EDIT_TOPICS_LIST_REQUEST = "STUDIO_EDIT_TOPICS_LIST_REQUEST"
export const STUDIO_EDIT_TOPICS_LIST_RESPONSE =
    "STUDIO_EDIT_TOPICS_LIST_RESPONSE"
export const STUDIO_EDIT_TOPICS_LIST_COUNT_REQUEST =
    "STUDIO_EDIT_TOPICS_LIST_COUNT_REQUEST"
export const STUDIO_EDIT_TOPICS_LIST_COUNT_RESPONSE =
    "STUDIO_EDIT_TOPICS_LIST_COUNT_RESPONSE"
export const STUDIO_EDIT_DIMENSIONS_LIST_REQUEST =
    "STUDIO_EDIT_DIMENSIONS_LIST_REQUEST"
export const STUDIO_EDIT_DIMENSIONS_LIST_RESPONSE =
    "STUDIO_EDIT_DIMENSIONS_LIST_RESPONSE"
export const STUDIO_EDIT_DIMENSIONS_LIST_COUNT_REQUEST =
    "STUDIO_EDIT_DIMENSIONS_LIST_COUNT_REQUEST"
export const STUDIO_EDIT_DIMENSIONS_LIST_COUNT_RESPONSE =
    "STUDIO_EDIT_DIMENSIONS_LIST_COUNT_RESPONSE"

// Community Actions
export const COMMUNITY_LIST_REQUEST = "COMMUNITY_LIST_REQUEST"
export const COMMUNITY_LIST_SEARCH_REQUEST = "COMMUNITY_LIST_SEARCH_REQUEST"
export const COMMUNITY_LIST_RESPONSE = "COMMUNITY_LIST_RESPONSE"
export const COMMUNITY_LIST_CACHED_RESPONSE = "COMMUNITY_LIST_CACHED_RESPONSE"
export const COMMUNITY_LIST_ERROR_RESPONSE = "COMMUNITY_LIST_ERROR_RESPONSE"
export const COMMUNITY_ITEM_SAVE_REQUEST = "COMMUNITY_ITEM_SAVE_REQUEST"
export const COMMUNITY_ITEM_SAVE_RESPONSE = "COMMUNITY_ITEM_SAVE_RESPONSE"
export const COMMUNITY_ITEM_REQUEST = "COMMUNITY_ITEM_REQUEST"
export const COMMUNITY_ITEM_RESPONSE = "COMMUNITY_ITEM_RESPONSE"
export const COMMUNITY_ITEM_CACHED_RESPONSE = "COMMUNITY_ITEM_CACHED_RESPONSE"
export const COMMUNITY_ITEM_ERROR_RESPONSE = "COMMUNITY_ITEM_ERROR_RESPONSE"
export const COMMUNITY_SET_FILTER = "COMMUNITY_SET_FILTER"
export const COMMUNITY_UPDATE_FILTER_CRITERIA =
    "COMMUNITY_UPDATE_FILTER_CRITERIA"
export const COMMUNITY_CLEAR_FILTER_CRITERIA = "COMMUNITY_CLEAR_FILTER_CRITERIA"
export const COMMUNITY_APPLY_FILTER_CRITERIA =
    "COMMUNNITY_APPLY_FILTER_CRITERIA"
export const COMMUNITY_UPDATE_IMAGE = "COMMUNITY_UPDATE_IMAGE"
export const COMMUNITY_UPDATE_MODEL = "COMMUNITY_UPDATE_MODEL"
export const COMMUNITY_APPLY_MODEL_UPDATE = "COMMUNITY_APPLY_MODEL_UPDATE"
export const COMMUNITY_CANCEL_MODEL_UPDATE = "COMMUNITY_CANCEL_MODEL_UPDATE"
export const COMMUNITY_SET_EDIT_MODE = "COMMUNITY_SET_EDIT_MODE"
export const COMMUNITY_CANCEL_ADDING_MEMBERS = "COMMUNITY_CANCEL_ADDING_MEMBERS"
export const COMMUNITY_APPLY_ADD_SELECTED_MEMBERS =
    "COMMUNITY_APPLY_ADD_SELECTED_MEMBERS"
export const COMMUNITY_SELECT_ADD_MEMBER = "COMMUNITY_SELECT_ADD_MEMBER"
export const COMMUNITY_SELECT_REMOVE_PARTICIPANT =
    "COMMUNITY_SELECT_REMOVE_PARTICIPANT"
export const COMMUNITY_PROMOTE_MEMBER = "COMMUNITY_PROMOTE_MEMBER"
export const COMMUNITY_ADD_NEW = "COMMUNITY_ADD_NEW"

// Community Participant Action
export const COMMUNITY_PARTICIPANT_LIST_REQUEST =
    "COMMUNITY_PARTICIPANT_LIST_REQUEST"
export const COMMUNITY_PARTICIPANT_LIST_SEARCH_REQUEST =
    "COMMUNITY_PARTICIPANT_LIST_SEARCH_REQUEST"
export const COMMUNITY_PARTICIPANT_LIST_INVALIDATION =
    "COMMUNITY_PARTICIPANT_LIST_INVALIDATION"

// Community Members Actions
export const COMMUNITY_MEMBERS_LIST_REQUEST = "COMMUNITY_MEMBERS_LIST_REQUEST"
export const COMMUNITY_MEMBERS_LIST_RESPONSE = "COMMUNITY_MEMBERS_LIST_RESPONSE"
export const COMMUNITY_MEMBERS_LIST_CACHED_RESPONSE =
    "COMMUNITY_MEMBERS_LIST_CACHED_RESPONSE"
export const COMMUNITY_MEMBERS_LIST_ERROR_RESPONSE =
    "COMMUNITY_MEMBERS_LIST_ERROR_RESPONSE"
export const COMMUNITY_MEMBERS_ADD_LIST_SEARCH_REQUEST =
    "COMMUNITY_MEMBERS_ADD_LIST_SEARCH_REQUEST"
export const COMMUNITY_MEMBERS_ADD_LIST_REQUEST =
    "COMMUNITY_MEMBERS_ADD_LIST_REQUEST"
export const COMMUNITY_MEMBERS_ADD_LIST_RESPONSE =
    "COMMUNITY_MEMBERS_ADD_LIST_RESPONSE"
export const COMMUNITY_MEMBERS_ADD_LIST_CACHED_RESPONSE =
    "COMMUNITY_MEMBERS_ADD_LIST_CACHED_RESPONSE"
export const COMMUNITY_MEMBERS_ADD_LIST_ERROR_RESPONSE =
    "COMMUNITY_MEMBERS_ADD_LIST_ERROR_RESPONSE"

// Community Managers Actions
export const COMMUNITY_MANAGERS_LIST_REQUEST = "COMMUNITY_MANAGERS_LIST_REQUEST"
export const COMMUNITY_MANAGERS_LIST_RESPONSE =
    "COMMUNITY_MANAGERS_LIST_RESPONSE"
export const COMMUNITY_MANAGERS_LIST_CACHED_RESPONSE =
    "COMMUNITY_MANAGERS_LIST_CACHED_RESPONSE"
export const COMMUNITY_MANAGERS_LIST_ERROR_RESPONSE =
    "COMMUNITY_MANAGERS_LIST_ERROR_RESPONSE"

// Community Followers Actions
export const COMMUNITY_FOLLOWERS_LIST_REQUEST =
    "COMMUNITY_FOLLOWERS_LIST_REQUEST"
export const COMMUNITY_FOLLOWERS_LIST_RESPONSE =
    "COMMUNITY_FOLLOWERS_LIST_RESPONSE"
export const COMMUNITY_FOLLOWERS_LIST_CACHED_RESPONSE =
    "COMMUNITY_FOLLOWERS_LIST_CACHED_RESPONSE"
export const COMMUNITY_FOLLOWERS_LIST_ERROR_RESPONSE =
    "COMMUNITY_FOLLOWERS_LIST_ERROR_RESPONSE"

// Community Invited Actions
export const COMMUNITY_INVITED_LIST_REQUEST = "COMMUNITY_INVITED_LIST_REQUEST"
export const COMMUNITY_INVITED_LIST_RESPONSE = "COMMUNITY_INVITED_LIST_RESPONSE"
export const COMMUNITY_INVITED_LIST_CACHED_RESPONSE =
    "COMMUNITY_INVITED_LIST_CACHED_RESPONSE"
export const COMMUNITY_INVITED_LIST_ERROR_RESPONSE =
    "COMMUNITY_INVITED_LIST_ERROR_RESPONSE"

// Community Awaiting Approval Actions
export const COMMUNITY_AWAITING_APPROVAL_LIST_REQUEST =
    "COMMUNITY_AWAITING_APPROVAL_LIST_REQUEST"
export const COMMUNITY_AWAITING_APPROVAL_LIST_RESPONSE =
    "COMMUNITY_AWAITING_APPROVAL_LIST_RESPONSE"
export const COMMUNITY_AWAITING_APPROVAL_LIST_CACHED_RESPONSE =
    "COMMUNITY_AWAITING_APPROVAL_LIST_CACHED_RESPONSE"
export const COMMUNITY_AWAITING_APPROVAL_LIST_ERROR_RESPONSE =
    "COMMUNITY_AWAITING_APPROVAL_LIST_ERROR_RESPONSE"

// User Actions

export const USER_ITEM_REQUEST = "USER_ITEM_REQUEST"
export const USER_ITEM_RESPONSE = "USER_ITEM_RESPONSE"
export const USER_ITEM_SAVE_REQUEST = "USER_ITEM_SAVE_REQUEST"
export const USER_ITEM_SAVE_RESPONSE = "USER_ITEM_SAVE_RESPONSE"
export const USER_ITEM_CACHED_RESPONSE = "USER_ITEM_CACHED_RESPONSE"
export const USER_ITEM_ERROR_RESPONSE = "USER_ITEM_ERROR_RESPONSE"
export const USER_LIST_REQUEST = "USER_LIST_REQUEST"
export const USER_LIST_SEARCH_REQUEST = "USER_LIST_SEARCH_REQUEST"
export const USER_LIST_RESPONSE = "USER_LIST_RESPONSE"
export const USER_LIST_CACHED_RESPONSE = "USER_LIST_CACHED_RESPONSE"
export const USER_LIST_ERROR_RESPONSE = "USER_LIST_ERROR_RESPONSE"
export const USERS_PAGE_LIST_REQUEST = "USERS_PAGE_LIST_REQUEST"
export const USERS_PAGE_LIST_RESPONSE = "USERS_PAGE_LIST_RESPONSE"
export const USER_SET_FILTER = "USER_SET_FILTER"
export const USER_SET_EDIT_MODE = "USER_SET_EDIT_MODE"
export const USER_UPDATE_FILTER_CRITERIA = "USER_UPDATE_FILTER_CRITERIA"
export const USER_CLEAR_FILTER_CRITERIA = "USER_CLEAR_FILTER_CRITERIA"
export const USER_APPLY_FILTER_CRITERIA = "USER_APPLY_FILTER_CRITERIA"
export const USER_UPDATE_IMAGE = "USER_UPDATE_IMAGE"
export const USER_UPDATE_MODEL = "USER_UPDATE_MODEL"
export const USER_APPLY_MODEL_UPDATE = "USER_APPLY_MODEL_UPDATE"
export const USER_CANCEL_MODEL_UPDATE = "USER_CANCEL_MODEL_UPDATE"
export const USER_ADD_NEW = "USER_ADD_NEW"

// Session Actions
export const SESSION_LIST_REQUEST = "SESSION_LIST_REQUEST"
export const SESSION_LIST_RESPONSE = "SESSION_LIST_RESPONSE"
export const SESSION_LIST_CACHED_RESPONSE = "SESSION_LIST_CACHED_RESPONSE"
export const SESSION_LIST_ERROR_RESPONSE = "SESSION_LIST_ERROR_RESPONSE"

// Project Actions
export const PROJECT_LIST_REQUEST = "PROJECT_LIST_REQUEST"
export const PROJECT_LIST_RESPONSE = "PROJECT_LIST_RESPONSE"
export const PROJECT_LIST_CACHED_RESPONSE = "PROJECT_LIST_CACHED_RESPONSE"
export const PROJECT_LIST_ERROR_RESPONSE = "PROJECT_LIST_ERROR_RESPONSE"

// Report Actions
export const REPORT_LIST_REQUEST = "REPORT_LIST_REQUEST"
export const REPORT_LIST_RESPONSE = "REPORT_LIST_RESPONSE"
export const REPORT_LIST_CACHED_RESPONSE = "REPORT_LIST_CACHED_RESPONSE"
export const REPORT_LIST_ERROR_RESPONSE = "REPORT_LIST_ERROR_RESPONSE"

// Placeholder Actions
export const PLACEHOLDER_ADD_REQUEST = "PLACEHOLDER_ADD_REQUEST"
export const PLACEHOLDER_ADD_RESPONSE = "PLACEHOLDER_ADD_RESPONSE"
export const PLACEHOLDER_ADD_ERROR_RESPONSE = "PLACEHOLDER_ADD_ERROR_RESPONSE"

// Stakeholder Actions
export const STAKEHOLDERS_PAGE_LIST_REQUEST = "STAKEHOLDERS_PAGE_LIST_REQUEST"
export const STAKEHOLDERS_PAGE_LIST_RESPONSE = "STAKEHOLDERS_PAGE_LIST_RESPONSE"
export const STAKEHOLDERS_PAGE_ITEM_REQUEST = "STAKEHOLDERS_PAGE_ITEM_REQUEST"
export const STAKEHOLDERS_PAGE_ITEM_RESPONSE = "STAKEHOLDERS_PAGE_ITEM_RESPONSE"
export const STAKEHOLDER_LIST_REQUEST = "STAKEHOLDER_LIST_REQUEST"
export const STAKEHOLDER_LIST_SEARCH_REQUEST = "STAKEHOLDER_LIST_SEARCH_REQUEST"
export const STAKEHOLDER_LIST_RESPONSE = "STAKEHOLDER_LIST_RESPONSE"
export const STAKEHOLDER_LIST_CACHED_RESPONSE =
    "STAKEHOLDER_LIST_CACHED_RESPONSE"
export const STAKEHOLDER_LIST_ERROR_RESPONSE = "STAKEHOLDER_LIST_ERROR_RESPONSE"
export const STAKEHOLDER_ITEM_REQUEST = "STAKEHOLDER_ITEM_REQUEST"
export const STAKEHOLDER_ITEM_RESPONSE = "STAKEHOLDER_ITEM_RESPONSE"
export const STAKEHOLDER_ITEM_CACHED_RESPONSE =
    "STAKEHOLDER_ITEM_CACHED_RESPONSE"
export const STAKEHOLDER_ITEM_SAVE_RESPONSE = "STAKEHOLDER_ITEM_SAVE_RESPONSE"
export const STAKEHOLDER_ITEM_ERROR_RESPONSE = "STAKEHOLDER_ITEM_ERROR_RESPONSE"
export const STAKEHOLDER_ITEM_SAVE_REQUEST = "STAKEHOLDER_ITEM_SAVE_REQUEST"
export const STAKEHOLDER_SET_FILTER = "STAKEHOLDER_SET_FILTER"
export const STAKEHOLDER_SET_EDIT_MODE = "STAKEHOLDER_SET_EDIT_MODE"
export const STAKEHOLDER_UPDATE_FILTER_CRITERIA =
    "STAKEHOLDER_UPDATE_FILTER_CRITERIA"
export const STAKEHOLDER_CLEAR_FILTER_CRITERIA =
    "STAKEHOLDER_CLEAR_FILTER_CRITERIA"
export const STAKEHOLDER_APPLY_FILTER_CRITERIA =
    "STAKEHOLDER_APPLY_FILTER_CRITERIA"
export const STAKEHOLDER_UPDATE_IMAGE = "STAKEHOLDER_UPDATE_IMAGE"
export const STAKEHOLDER_UPDATE_MODEL = "STAKEHOLDER_UPDATE_MODEL"
export const STAKEHOLDER_APPLY_MODEL_UPDATE = "STAKEHOLDER_APPLY_MODEL_UPDATE"
export const STAKEHOLDER_CANCEL_MODEL_UPDATE = "STAKEHOLDER_CANCEL_MODEL_UPDATE"
export const STAKEHOLDER_ADD_NEW = "STAKEHOLDER_ADD_NEW"
export const STAKEHOLDER_FINISH_SAVING = "STAKEHOLDER_FINISH_SAVING"
export const STAKEHOLDER_FINISH_SAVING_ERROR = "STAKEHOLDER_FINISH_SAVING_ERROR"
export const STAKEHOLDER_SHOW_INVALID_FIELDS = "STAKEHOLDER_SHOW_INVALID_FIELDS"
export const STAKEHOLDER_UPDATE_FILTER_TYPE = "STAKEHOLDER_UPDATE_FILTER_TYPE"

// Role Actions
export const ROLE_LIST_REQUEST = "ROLE_LIST_REQUEST"
export const ROLE_LIST_RESPONSE = "ROLE_LIST_RESPONSE"
export const ROLE_LIST_CACHED_RESPONSE = "ROLE_LIST_CACHED_RESPONSE"
export const ROLE_LIST_ERROR_RESPONSE = "ROLE_LIST_ERROR_RESPONSE"
export const ROLE_ITEM_SAVE_REQUEST = "ROLE_ITEM_SAVE_REQUEST"
export const ROLE_ITEM_SAVE_RESPONSE = "ROLE_ITEM_SAVE_RESPONSE"
export const ROLE_ITEM_ERROR_RESPONSE = "ROLE_ITEM_ERROR_RESPONSE"
export const ROLE_ITEM_DELETE_REQUEST = "ROLE_ITEM_DELETE_REQUEST"
export const ROLE_ITEM_DELETE_RESPONSE = "ROLE_ITEM_DELETE_RESPONSE"
export const ROLE_ADD = "ROLE_ADD"
export const ROLE_REMOVE = "ROLE_REMOVE"
export const ROLE_EDIT = "ROLE_EDIT"
export const ROLE_APPROVE = "ROLE_APPROVE"
export const ROLE_REJECT = "ROLE_REJECT"

// Evidence Actions
export const EVIDENCE_LIST_REQUEST = "EVIDENCE_LIST_REQUEST"
export const EVIDENCE_LIST_RESPONSE = "EVIDENCE_LIST_RESPONSE"
export const EVIDENCE_LIST_CACHED_RESPONSE = "EVIDENCE_LIST_CACHED_RESPONSE"
export const EVIDENCE_LIST_ERROR_RESPONSE = "EVIDENCE_LIST_ERROR_RESPONSE"
export const EVIDENCE_ADD_REQUEST = "EVIDENCE_ADD_REQUEST"
export const EVIDENCE_ADD_RESPONSE = "EVIDENCE_ADD_RESPONSE"
export const EVIDENCE_ITEM_ERROR_RESPONSE = "EVIDENCE_ITEM_ERROR_RESPONSE"
export const EVIDENCE_ITEM_SAVE_REQUEST = "EVIDENCE_ITEM_SAVE_REQUEST"
export const EVIDENCE_ITEM_SAVE_RESPONSE = "EVIDENCE_ITEM_SAVE_RESPONSE"
export const EVIDENCE_REMOVE_ITEM = "EVIDENCE_REMOVE_ITEM"
export const EVIDENCE_ITEM_DELETE_REQUEST = "EVIDENCE_ITEM_DELETE_REQUEST"
export const EVIDENCE_ITEM_DELETE_RESPONSE = "EVIDENCE_ITEM_DELETE_RESPONSE"

export const NOTIFICATION_ITEM_REQUEST = "NOTIFICATION_ITEM_REQUEST"
export const NOTIFICATION_ITEM_RESPONSE = "NOTIFICATION_ITEM_RESPONSE"
export const NOTIFICATION_ITEM_SAVE_RESPONSE = "NOTIFICATION_ITEM_SAVE_RESPONSE"
export const NOTIFICATION_ITEM_CACHED_RESPONSE =
    "NOTIFICATION_ITEM_CACHED_RESPONSE"
export const NOTIFICATION_ITEM_DELETE_REQUEST =
    "NOTIFICATION_ITEM_DELETE_REQUEST"
export const NOTIFICATION_ITEM_DELETE_RESPONSE =
    "NOTIFICATION_ITEM_DELETE_RESPONSE"
export const NOTIFICATION_ITEM_DELETE_ERROR_RESPONSE =
    "NOTIFICATION_ITEM_DELETE_ERROR_RESPONSE"
export const NOTIFICATION_LIST_REQUEST = "NOTIFICATION_LIST_REQUEST"
export const NOTIFICATION_LIST_RESPONSE = "NOTIFICATION_LIST_RESPONSE"
export const NOTIFICATION_LIST_CACHED_RESPONSE =
    "NOTIFICATION_LIST_CACHED_RESPONSE"
export const NOTIFICATION_LIST_ERROR_RESPONSE =
    "NOTIFICATION_LIST_ERROR_RESPONSE"
export const NOTIFICATION_SET_FILTER = "NOTIFICATION_SET_FILTER"
export const NOTIFICATION_SET_EDIT_MODE = "NOTIFICATION_SET_EDIT_MODE"
export const NOTIFICATION_UPDATE_FILTER_CRITERIA =
    "NOTIFICATION_UPDATE_FILTER_CRITERIA"
export const NOTIFICATION_CLEAR_FILTER_CRITERIA =
    "NOTIFICATION_CLEAR_FILTER_CRITERIA"
export const NOTIFICATION_UPDATE_MODEL = "NOTIFICATION_UPDATE_MODEL"
export const NOTIFICATION_APPLY_MODEL_UPDATE = "NOTIFICATION_APPLY_MODEL_UPDATE"
export const NOTIFICATION_CANCEL_MODEL_UPDATE =
    "NOTIFICATION_CANCEL_MODEL_UPDATE"
export const NOTIFICATION_ADD_NEW = "NOTIFICATION_ADD_NEW"
export const NOTIFICATION_LIST_SEARCH_REQUEST =
    "NOTIFICATION_LIST_SEARCH_REQUEST"
export const NOTIFICATION_ITEM_ERROR_RESPONSE =
    "NOTIFICATION_ITEM_ERROR_RESPONSE"
export const NOTIFICATION_ITEM_SAVE_REQUEST = "NOTIFICATION_ITEM_SAVE_REQUEST"
export const NOTIFICATION_APPLY_FILTER_CRITERIA =
    "NOTIFICATION_APPLY_FILTER_CRITERIA"
export const NOTIFICATION_TOGGLE_EXPIRES = "NOTIFICATION_TOGGLE_EXPIRES"
export const NOTIFICATION_ITEM_ENTITY_REQUEST =
    "NOTIFICATION_ITEM_ENTITY_REQUEST"
export const NOTIFICATION_ITEM_ENTITY_RESPONSE =
    "NOTIFICATION_ITEM_ENTITY_RESPONSE"
export const NOTIFICATION_ITEM_ENTITY_ERROR_RESPONSE =
    "NOTIFICATION_ITEM_ENTITY_ERROR_RESPONSE"
